import { BASE_API } from "../utils/constants";

export async function getExtraGroupsApi() {
  try {
    const url = `${BASE_API}/api/extra-groups/`;
    const response = await fetch(url);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

export async function addExtraGroupApi(data, token) {
  try {
    const url = `${BASE_API}/api/extra-groups/`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

export async function updateExtraGroupApi(id, data, token) {
  try {
    const url = `${BASE_API}/api/extra-groups/${id}/`;
    const params = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

export async function deleteExtraGroupApi(id, token) {
  try {
    const url = `${BASE_API}/api/extra-groups/${id}/`;
    const params = {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}
